// extracted by mini-css-extract-plugin
export default {"notFound":"NotFound_notFound__Af8rF","title":"NotFound_title__kMCxa","dark":"NotFound_dark__mFWjM"};